import { type ReactNode } from 'react'

import { Flex } from 'antd'

type SectionWrapperProps = {
  title: string
  middle: ReactNode
  bottom: ReactNode
  style?: React.CSSProperties
}

export const StatisticsSectionWrapper = ({
  title,
  middle,
  bottom,
  style,
}: SectionWrapperProps) => (
  <section
    style={{
      backgroundColor: 'rgba(0, 0, 0, 0.05)',
      borderRadius: 8,
      paddingTop: 16,
      paddingLeft: 12,
      paddingRight: 12,
      paddingBottom: 10,
      height: '100%',
      ...style,
    }}
  >
    <Flex vertical style={{ height: '100%' }} justify="center">
      <Flex vertical gap={8}>
        <Flex
          style={{
            height: '40px',
          }}
          vertical
          justify="end"
        >
          <span
            style={{
              fontSize: '14px',
              fontWeight: '400',
              color: 'rgba(0, 0, 0, 0.45)',
            }}
          >
            {title}
          </span>
        </Flex>
        <Flex
          style={{ height: '40px', fontSize: '30px', fontWeight: '600' }}
          align="center"
        >
          {middle}
        </Flex>
        <Flex style={{ height: '50px' }} align="start">
          {bottom}
        </Flex>
      </Flex>
    </Flex>
  </section>
)
